import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useTranslation } from 'src/text';
import { useExpenses } from '../expense-context';

export const ExpenseList: React.FC = () => {
  const { expenseLabels } = useTranslation();
  const { expenses, deleteExpense } = useExpenses();
  const categoryLabels = expenseLabels.categories;

  if (expenses.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {expenseLabels.listEmpty}
      </Typography>
    );
  }

  return (
    <List dense disablePadding>
      {expenses.map(exp => (
        <ListItem
          key={exp.id}
          disableGutters
          secondaryAction={
            <IconButton
              edge="end"
              size="small"
              onClick={() => deleteExpense(exp.id)}>
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          }>
          <ListItemText
            primaryTypographyProps={{ variant: 'subtitle2' }}
            secondaryTypographyProps={{ variant: 'caption' }}
            primary={
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="subtitle2">{exp.description}</Typography>
                <Chip size="small" label={categoryLabels[exp.category]} />
              </Stack>
            }
            secondary={`${exp.paymentMethod || expenseLabels.paymentFallback} · ${new Date(exp.date).toLocaleDateString()}`}
          />
          <Typography variant="subtitle2">${exp.amount.toFixed(2)}</Typography>
        </ListItem>
      ))}
    </List>
  );
};
